import { times } from "../Submit/SaveAnswer";

export function handleTimes(times:times, showTimeAnalysis:boolean){
    if (showTimeAnalysis){
        const html = '<div class="form-wrapper p-0 position-relative">' + 
        '<span class="position-absolute" style="top: 7px; right: 7px;" onclick="showQuestion(1);"><i class="fa fa-question-circle"></i></span>' +
        '<div id="chartContainer" class="p-4" style="min-height: 365px"></div>' +
        '</div>';
        $(".all-tasks-wrapper").before(html)

        showTimes(times);
    }
}

export function formatZeit(s:number):string{
    const minEdit = s / 60;
    const min = Math.floor(minEdit);
    let sek = Math.round(s % 60);
    if (sek < 10){
        sek = "0" + sek;
    }
    return min + ":" + sek;
}

function showTimes(times){

    const totalTime = times.used_time;

    let haveToShowGreen = false;
    let haveToShowRed = false;
    const editTimes = [];
    const labels = [];
    const timeLeft = [];
    const timeNegative = [];

    

    let ind = 0;
    for (const [taskId, value] of Object.entries(times.tasks)){
        ind += 1;
        let leftTime = 0;
        let negativeTime = 0;
        let editTime = value.time / 1000; 
        
        const expectedTime = value.expected / 1000;

        if (editTime < expectedTime){
            haveToShowGreen = true;
            leftTime = expectedTime - editTime;
        } else {
            haveToShowRed = true; // now we have to have another series
            negativeTime = editTime - expectedTime;
            editTime = expectedTime;
        }

        labels.push("Aufgabe " + ind)
        editTimes.push(Math.round(editTime));
        timeLeft.push(Math.round(leftTime));
        timeNegative.push(Math.round(negativeTime));
    }

    const series = [{
        "name": "Bearbeitungszeit",
        "data": editTimes,
    }]

    if (haveToShowGreen){
        series.push({
            "name": "Übrige Zeit",
            "data": timeLeft,
        })
    }

    if (haveToShowRed){
        series.push({
            "name": "Überzogene Zeit",
            "data": timeNegative,
        })
    }


    const options = {
        "series": series,
        "chart": {
          "type": "bar",
          "height": 350,
          "stacked": true
        },
        "plotOptions": {
          "bar": {
            "horizontal": true
          }
        },
        "stroke": {
          "width": 1,
          "colors": [
            "#fff"
          ]
        },
        "title": {
          "text": "Gesamtbearbeitungszeit: " + formatZeit(totalTime / 1000)
        },
        "xaxis": {
          "categories": labels,
          "labels": {
              formatter: function(val){
                    return formatZeit(val);
              }
          }
        },
        "fill": {
          "opacity": 1
        },
        "legend": {
          "position": "top",
          "horizontalAlign": "left",
          "offsetX": 60
        },
        "dataLabels": {
            formatter: function(val){
                if (val != 0){
                    return formatZeit(val);
                } else {
                    return '';
                }
            }
        },
        "tooltip": {
            y: {
                formatter: function(val){
                    return formatZeit(val);
                }
            }
        }
    }

    const chart = new ApexCharts(document.querySelector("#chartContainer"), options);
    if (chart !== undefined && chart !== null){
        chart.render();
    }


}